import loadable from "@loadable/component";
import { createBrowserRouter, Navigate } from "react-router-dom";

const Layout = loadable(() => import("../layout"));
const Home = loadable(() => import("../pages/Home"));
const Enrichment = loadable(() => import("../pages/Enrichment"));
const SignAsUser = loadable(() => import("../pages/SignAsUser"));
const Blacklist = loadable(() => import("../pages/Blacklist"));
const Answers = loadable(() => import("../pages/Answers"));
const Results = loadable(() => import("../pages/Results"));
const Forms = loadable(() => import("../pages/Forms"));
const Import = loadable(() => import("../pages/Import"));
const Exports = loadable(() => import("../pages/Exports"));
const DetailsResults = loadable(() => import("../pages/DetailsResults"));
const CreateCampaign = loadable(() => import("../pages/CreateCampaign"));
const Campaign = loadable(() => import("../pages/Campaign"));
const BiDetail = loadable(() => import("../pages/BI/Detail"));
const BI = loadable(() => import("../pages/BI"));
const BiDashboard = loadable(() => import("../pages/BI/Dashboard"));
const EmailTemplates = loadable(() => import("../pages/EmailTemplates"));
const DetailsPerson = loadable(() => import("../pages/DetailsPerson"));
const Offers = loadable(() => import("../pages/Offers"));
const DetailsOffers = loadable(() => import("../pages/DetailsOffers"));
const CampaignAwarded = loadable(() => import("../pages/CampaignAwarded"));
const CampaignAwardedId = loadable(() => import("../pages/CampaignAwardedId"));
const NewStore = loadable(() => import("../pages/DeliveryVip"));
const WithoutAccess = loadable(() => import("../pages/WithoutAcess"));
const Error = loadable(() => import("../pages/Error"));
const NotFound = loadable(() => import("../pages/NotFound"));
const ResultsOffers = loadable(() => import("../pages/ResultsOffers"));
const Learning = loadable(() => import("../pages/Learning"));
const Training = loadable(() => import("../pages/Training"));
const Calls = loadable(() => import("../pages/Calls"));

const permissions = JSON.parse(localStorage.getItem("@datasales:permissions")!);
const hasAllPermission =
  permissions?.crm?.filter((e) => e?.serviceId === 73)?.length !== 0;
const hasDisparoPermission =
  permissions?.crm?.filter((e) => e?.serviceId === 79)?.length !== 0;
const hasDescontoPermission =
  permissions?.crm?.filter((e) => e?.serviceId === 80)?.length !== 0;
const hasPersonalizadaPermission =
  permissions?.crm?.filter((e) => e?.serviceId === 81)?.length !== 0;
const hasEnriquecimentoPermission =
  permissions?.crm?.filter((e) => e?.serviceId === 82)?.length !== 0;
const hasClubeDescontosPermission =
  permissions?.crm?.filter((e) => e?.serviceId === 77)?.length !== 0;

export const router = createBrowserRouter([
  {
    id: "hidden-menu-initial",
    path: "/",
    element: <Navigate to="/overview" replace />,
    errorElement: <Error />,
  },
  {
    id: "hidden-menu-home",
    path: "/home",
    element: <Navigate to="/overview" replace />,
    errorElement: <Error />,
  },
  {
    id: "hidden-sign-token",
    path: "/sign-as-user/:token",
    errorElement: <Error />,
    element: <SignAsUser />,
  },
  {
    id: "-add-divider",
    path: "/overview",
    errorElement: <Error />,
    element: (
      <Layout>
        <Home />
      </Layout>
    ),
  },
  {
    id: "hidden-menu-view-estudio",
    path: "/blacklist",
    element: (
      <Layout>
        <Blacklist />
      </Layout>
    ),
    errorElement: <Error />,
  },
  {
    id: "hidden-menu-studio-whitelabel",
    path: "/answers",
    errorElement: <Error />,
    element: (
      <Layout>
        <Answers />
      </Layout>
    ),
  },
  {
    id: "hidden-menu-studio-delivery",
    path: "/form-delivery",
    errorElement: <Error />,
    element: (
      <Layout>
        <NewStore />
      </Layout>
    ),
  },
  {
    id: "hidden-menu-resuslts",
    path: "/results/:id",
    errorElement: <Error />,
    element: (
      <Layout>
        <DetailsResults />
      </Layout>
    ),
  },
  {
    id: "hidden-menu-6",
    path: "/create-campaign",
    errorElement: <Error />,
    element: (
      <Layout>
        <CreateCampaign />
      </Layout>
    ),
  },
  {
    id: "view-campaign",
    path: "/campaign-list",
    errorElement: <Error />,
    element: (
      <Layout>
        <Campaign />
      </Layout>
    ),
  },
  {
    id: `${
      !hasAllPermission && !hasClubeDescontosPermission && "hidden-menu-"
    }offers-offers`,
    path: "/offers",
    errorElement: <Error />,
    element: (
      <Layout>
        <Offers />
      </Layout>
    ),
  },
  {
    id: "campaign-awarded-add-divider",
    path: "/campaign-awarded",
    errorElement: <Error />,
    element: (
      <Layout>
        <CampaignAwarded />
      </Layout>
    ),
  },
  {
    id: `${
      !hasAllPermission && !hasDisparoPermission && "hidden-menu-"
    }studio-canva`,
    path: "/result-campaign",
    errorElement: <Error />,
    element: (
      <Layout>
        <Results />
      </Layout>
    ),
  },
  {
    id: `${
      !hasAllPermission && !hasDescontoPermission && "hidden-menu-"
    }studio-offers`,
    path: "/results-offers",
    errorElement: <Error />,
    element: (
      <Layout>
        <ResultsOffers />
      </Layout>
    ),
  },
  {
    id: `${
      !hasAllPermission && !hasPersonalizadaPermission && "hidden-menu-"
    }bi-whatsapp-add-divider`,
    path: "/bi",
    errorElement: <Error />,
    element: (
      <Layout>
        <BI />
      </Layout>
    ),
  },
  {
    path: "/imports",
    errorElement: <Error />,
    element: (
      <Layout>
        <Import />
      </Layout>
    ),
  },
  {
    path: "/exports",
    errorElement: <Error />,
    element: (
      <Layout>
        <Exports />
      </Layout>
    ),
  },
  {
    id: `${
      !hasAllPermission && !hasEnriquecimentoPermission && "hidden-menu-"
    }-view-enrichment`,
    path: "/enrichment",
    errorElement: <Error />,
    element: (
      <Layout>
        <Enrichment />
      </Layout>
    ),
  },
  {
    id: "studio-create-forms-add-divider",
    path: "/forms",
    errorElement: <Error />,
    element: (
      <Layout>
        <Forms />
      </Layout>
    ),
  },
  {
    id: "hidden-menu-bi-divider",
    path: "/bi/:biId",
    errorElement: <Error />,
    element: (
      <Layout>
        <BiDetail />
      </Layout>
    ),
  },
  {
    id: "hidden-menu-add-divider",
    path: "/bi/:biId/:dashboardId",
    errorElement: <Error />,
    element: (
      <Layout>
        <BiDashboard />
      </Layout>
    ),
  },
  {
    id: "hidden-menu-view-radioa",
    path: "/templates",
    errorElement: <Error />,
    element: (
      <Layout>
        <EmailTemplates />
      </Layout>
    ),
  },
  {
    id: "hidden-menu-view-radios",
    path: "/campaign-awarded/:id",
    errorElement: <Error />,
    element: (
      <Layout>
        <CampaignAwardedId />
      </Layout>
    ),
  },
  {
    id: "hidden-menu-view-people",
    path: "/people/:id",
    errorElement: <Error />,
    element: (
      <Layout>
        <DetailsPerson />
      </Layout>
    ),
  },
  {
    id: "hidden-menu-results",
    path: "/results-offers/:id",
    errorElement: <Error />,
    element: (
      <Layout>
        <DetailsOffers />
      </Layout>
    ),
  },
  {
    id: "hidden-menu-default-error",
    path: "*",
    errorElement: <Error />,
    element: (
      <Layout>
        <NotFound />
      </Layout>
    ),
  },
  {
    id: "hidden-menu-distribution",
    path: "/campaign-awarded",
    errorElement: <Error />,
    element: (
      <Layout>
        <CampaignAwarded />
      </Layout>
    ),
  },
  {
    id: "hidden-menu-onboarding",
    path: "/withou-access",
    errorElement: <Error />,
    element: <WithoutAccess />,
  },
  {
    path: "/learning",
    errorElement: <Error />,
    element: (
      <Layout>
        <Learning />
      </Layout>
    ),
  },
  {
    path: "/training",
    errorElement: <Error />,
    element: (
      <Layout>
        <Training />
      </Layout>
    ),
  },
  {
    path: "/calls",
    errorElement: <Error />,
    element: (
      <Layout>
        <Calls />
      </Layout>
    ),
  },
]);
